<template>
  <div class="tabs">
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick">
      <el-tab-pane
        label="Partyline"
        name="first">
        <TextArea />
        <Subscribe />
        <Card />
      </el-tab-pane>
      <el-tab-pane
        label="Gallery"
        name="second">
        <GallerySubscription />
      </el-tab-pane>
      <el-tab-pane
        label="Commentator"
        name="third">Commentator</el-tab-pane>
      <el-tab-pane
        label="Conference"
        name="fourth">Conference</el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Card from '@/components/Card.vue'
import TextArea from '@/components/TextArea.vue'
import Subscribe from '@/components/Subscribe.vue'
import GallerySubscription from '@/components/Gallery/GallerySubscription.vue'
export default {
  name: 'Tabs',
  components: {
    Card,
    TextArea,
    Subscribe,
    GallerySubscription
  },
  data () {
    return {
      activeName: 'first'
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style>
.el-tabs__active-bar {
  background-color: #67c23a !important;
}

.el-tabs__item {
  text-transform: uppercase;
  text-align: center;
}
.el-tabs__item.is-active {
  color: #67c23a !important;
}
.el-tabs__item:hover {
  color: #67c23a !important;
}
.el-tabs__nav-scroll {
  display: flex;
  justify-content: center;
}
.home .el-tabs__item {
  color: #777777;
  font-weight: bold;
  font-size: 14px;
  height: 50px;
}
.home .el-tabs__active-bar {
  height: 4px;
  border-radius: 2px;
}
.home .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 30px 0 15px;
}
.subscribe .el-button {
  background: #7cc855;
}
</style>
